"use client";

import Input from "@client/components/formik/input";
import Fieldset from "@client/components/lead-form/components/fieldset";
import type ButterCMS from "@packages/types/buttercms";
import { setUserInteractionDataAttribute } from "@shared/constants";
import kebabToCamelCase from "@shared/functions/kebabToCamelCase";
import type { CommonTileProps } from "@ui/js/components/tiles/common-tile-resources";
import { Tile } from "@ui/js/components/tiles/tile";
import { useFormikContext } from "formik";

const INPUT_ID_AND_LABEL_HTMLFOR = "tiles-column";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function TilesColumn({
	color = "primary",
	componentStyle = "default",
	labelTextField,
	tiles,
}: {
	color?: CommonTileProps["color"];
	componentStyle?: CommonTileProps["componentStyle"];
	labelTextField?: string;
	tiles: ButterCMS.InfoSection.NewTile[];
}) {
	const { setFieldValue, values } = useFormikContext<any>();

	// Get the current value from Formik context
	const currentValue = values[FIELD_NAME_SELECTOR] || "";

	const handleClick = (e: any) => {
		setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
	};
	return (
		<Fieldset legend={labelTextField}>
			<Input
				type="hidden"
				name={FIELD_NAME_SELECTOR}
				id={INPUT_ID_AND_LABEL_HTMLFOR}
				value={currentValue}
			/>
			{tiles.map((tile, index) => {
				return (
					<Tile
						{...setUserInteractionDataAttribute(
							`new-hero-tile-column__${tile.label}__${tile.value}__${INPUT_ID_AND_LABEL_HTMLFOR}__${FIELD_NAME_SELECTOR}`,
						)}
						color={color}
						componentStyle={componentStyle}
						key={index}
						iconLeft={
							<i className={`fa-solid ${tile.icon} text-lg`} aria-hidden></i>
						}
						label={tile.label}
						value={tile.value}
						onClick={handleClick}
					/>
				);
			})}
		</Fieldset>
	);
}
